import { MouseEvent } from 'react';
import cn from 'classnames';

import { DashbaordMyBizItem } from '@/api/pc-api/v1/mybiz/list/dashboard';
import Button from '@/components/common/Button';
import Tooltip from '@/components/Tooltip';
import { BIZ_TYPE, BizType } from '@/constants/bizType';
import { isBadgedPartnerRegStatus, PARTNER_REG_STATUS_BADGE } from '@/constants/partnerRegStatus';
import { ROLE } from '@/constants/role';
import { getCompanyName, getDealerName } from '@/utils/myBiz';

type Props = {
  data: DashbaordMyBizItem;
  onClickMyBiz: (e: MouseEvent<HTMLAnchorElement>, myBiz: DashbaordMyBizItem) => void;
  onClickRegisterApp: (e: MouseEvent<HTMLButtonElement>, myBiz: DashbaordMyBizItem) => void;
};

const MyBizItem = ({ data, onClickMyBiz, onClickRegisterApp }: Props) => {
  const { authInfoId, partnerCompanyName, dealerCompanyName, bizType, bizTargetType, role, partnerRegStatus } = data;
  const companyName = getCompanyName(partnerCompanyName, dealerCompanyName);
  const dealerName = getDealerName(bizTargetType, dealerCompanyName);
  const badgeStatus = isBadgedPartnerRegStatus(partnerRegStatus) ? partnerRegStatus : undefined;

  return (
    <li key={authInfoId}>
      <a href="#none" className={cn('link_mybiz', { disabled: !!badgeStatus })} onClick={(e) => onClickMyBiz(e, data)}>
        <span
          className={cn('ico_wallet', {
            ico_biz1: bizType === BizType.EDOC,
            ico_biz2: bizType === BizType.SET4,
            ico_biz3: bizType === BizType.MYDATA_CORP,
            ico_biz4: bizType === BizType.EPROOF
          })}
        >
          {bizType}
        </span>
        <span className="item_mybiz">
          <strong className="tit_mybiz">
            {companyName} ({BIZ_TYPE[bizType]})
          </strong>
          <span className="area_info">
            <span className="txt_authority">{ROLE[role]}</span>
            {dealerName && <span className="txt_dealer">{dealerName}</span>}
          </span>
        </span>
        {badgeStatus && (
          <Tooltip.Wrapper type="center">
            <Button size="m" variant="secondary01" onClick={(e) => onClickRegisterApp(e, data)}>
              <span className="ico_wallet ico_bang"></span>
              <span className="txt_btn">{PARTNER_REG_STATUS_BADGE[badgeStatus]}</span>
            </Button>
            <Tooltip.Box>
              <div className="txt_tooltip">
                - 이용기관 등록 완료를 위해 필수 정보 입력이 필요한 상태입니다.
                <br />- 정보 입력을 위한 기관 정보 등록 페이지로 이동합니다.
              </div>
            </Tooltip.Box>
          </Tooltip.Wrapper>
        )}
        <span className="ico_wallet ico_arr_r_24">페이지이동</span>
      </a>
    </li>
  );
};

export default MyBizItem;
